import { render, staticRenderFns } from "./MenuAppointmentModals.vue?vue&type=template&id=6d795cc3&"
import script from "./MenuAppointmentModals.vue?vue&type=script&lang=js&"
export * from "./MenuAppointmentModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports